import SeoHead from "@/components/SeoHead";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { Link } from "react-router-dom";

const services = [
  {
    id: "carrelage",
    icon: "ri-home-4-line",
    title: "Pose de carrelage",
    subtitle: "Sols & murs, anciens ou neufs",
    imgPosition: "object-bottom" as const,
    img: "/images/services-pose.jpg",
    description: `La pose de carrelage, c'est ce qu'on fait depuis 20 ans. Sol neuf, ancien carrelage à recouvrir, mur à habiller — on s'adapte à la surface et on trouve la bonne technique.

On travaille avec les carrelages disponibles chez les fournisseurs suisses et européens. Du grand format 120×120 aux petits carreaux décoratifs, on sait les poser droits, les couper nets, et faire des joints qui tiennent. Imitation béton, imitation bois, pierre naturelle ou céramique colorée — on vous aide à choisir en fonction de l'usage et du budget.

Le résultat ? Des sols plats, des murs d'aplomb, et des finitions qui ne se dégradent pas au fil des saisons. C'est le minimum qu'on se doit.`,
    features: [
      "Pose sur sol neuf ou ancien carrelage",
      "Grand format jusqu'à 120×120 cm",
      "Carrelage imitation béton, bois, pierre",
      "Joints époxy ou ciment coloré",
      "Découpe laser pour finitions parfaites",
      "Sous-couche d'isolation phonique",
    ],
  },
  {
    id: "salle-de-bain",
    icon: "ri-drop-line",
    title: "Rénovation salle de bain",
    subtitle: "Transformation complète de A à Z",
    img: "/images/services-renovation.jpg",
    description: `La rénovation de salle de bain, c'est notre terrain de jeu. On démonte l'ancien, on refait les installations si besoin, on pose le carrelage, on monte le mobilier — et à la fin, vous avez une salle de bain qui fonctionne et qui dure.

On coordonne les différents corps de métier pour que vous n'ayez pas à gérer cinq artisans différents. Plomberie, électricité, carrelage, installation sanitaire — on connaît les bons du coin et on fait en sorte que tout se passe dans le bon ordre.

Chaque salle de bain est différente. On ne copie pas un modèle, on écoute ce dont vous avez besoin — douche ou baignoire, rangements, éclairage — et on construit en fonction. Les délais sont ceux du chantier, pas des promesses marketing.`,
    features: [
      "Démolition et évacuation des gravats",
      "Plomberie et installation sanitaire",
      "Carrelage mural et au sol",
      "Pose de baignoire, douche, lavabo",
      "Mobilier de salle de bain sur mesure",
      "Éclairage et électricité",
    ],
  },
  {
    id: "douche-italienne",
    icon: "ri-water-flash-line",
    title: "Douche italienne",
    subtitle: "Élégance et modernité",
    img: "/images/services-douche-alt.jpg",
    description: `La douche à l'italienne, c'est pratique et c'est propre quand c'est bien fait. Pas de receveur qui jaunit, pas de joints moisis dans les coins — juste un sol qui pente légèrement vers le siphon et un carrelage antidérapant choisi avec soin.

On réalise des douches italiennes sur mesure : receveur encastré dans la dalle, pente calculée au millimètre, siphon discret, paroi vitrée ou walk-in selon ce qui vous convient. Les niches intégrées dans le mur pour ranger les produits, c'est un détail qui change la vie au quotidien.

On prend le temps de bien faire l'étanchéité. C'est le seul moyen d'éviter les mauvaises surprises deux ans plus tard. Une douche italienne mal faite, ça fuit. La nôtre, non.`,
    features: [
      "Receveur encastré sur mesure",
      "Siphon de sol design invisible",
      "Paroi vitrée ou walk-in",
      "Carrelage antidérapant certifié",
      "Niche intégrée pour rangement",
      "Robinetterie thermostatique",
    ],
  },
  {
    id: "faience-mosaique",
    icon: "ri-layout-grid-line",
    title: "Faïence & mosaïque",
    subtitle: "Décoration et personnalisation",
    img: "/images/services-faience.jpg",
    description: `La faïence murale et la mosaïque, c'est ce qui donne du caractère à une salle de bain ou une cuisine. Crédence, mur de douche, contour de baignoire — avec de la faïence bien posée, un espace simple devient un espace avec de l'allure.

On pose de la faïence en céramique, en grès cérame, en verre ou en pierre naturelle. Pour la mosaïque, on travaille avec des formats petits, moyens ou des motifs géométriques sur mesure. Le résultat dépend autant du choix des matériaux que de la précision de la pose — et c'est justement là qu'on intervient.

Une mosaïque mal alignée, c'est visible immédiatement. On coupe propre, on pose droit, on joint avec soin. C'est du travail de patience, et c'est ce qu'on aime.`,
    features: [
      "Faïence céramique et grès cérame",
      "Mosaïque verre, marbre, inox",
      "Motifs géométriques sur mesure",
      "Crédences cuisine et salle de bain",
      "Habillage de piscine et spa",
      "Pose en diagonale ou en chevron",
    ],
  },
  {
    id: "exterieur",
    icon: "ri-sun-line",
    title: "Carrelage extérieur",
    subtitle: "Terrasses, allées & piscines",
    imgPosition: "object-center" as const,
    img: "/images/services-exterieur.jpg",
    description: `Le carrelage extérieur en Valais, c'est une autre paire de manches. Le gel, les UV, la neige, le sel — il faut des matériaux qui tiennent le coup et une pose qui ne laisse pas l'eau s'infiltrer.

On pose du grès cérame technique sur les terrasses, les allées, les contours de piscine. Antidérapant certifié, résistant au gel, avec des joints spéciaux extérieur qui ne se fissurent pas aux premières gelées. On adapte la pose à la pente et à l'écoulement des eaux.

En Valais, surtout en altitude à Crans-Montana ou Verbier, les variations de température sont violentes. Un carrelage extérieur mal posé se soulève au bout d'un hiver. Le nôtre, on le pose pour qu'il dure.`,
    features: [
      "Grès cérame résistant au gel",
      "Antidérapant certifié R11/R12",
      "Terrasses et plages de piscine",
      "Allées et escaliers extérieurs",
      "Joints spéciaux extérieur",
      "Traitement hydrofuge disponible",
    ],
  },
  {
    id: "petits-espaces",
    icon: "ri-tools-line",
    title: "Optimisation petits espaces",
    subtitle: "Studios, WC, buanderies",
    img: "/images/services-petits-espaces.jpg",
    description: `Les petits espaces, c'est notre quotidien. WC de 2 m², buanderie sous escalier, salle de bain de studio où on doit caser douche, lavabo et toilettes dans 4 m² — on sait faire.

Le truc, c'est de ne rien perdre. Carrelage en diagonale pour donner de l'ampleur, niches de rangement moulées dans le mur, douche compacte avec paroi coulissante, mobilier sur mesure qu'on fait poser au millimètre. Chaque centimètre est utile.

On vous conseille sur les formats de carrelage qui agrandissent visuellement, les couleurs qui apportent de la lumière, et les solutions techniques qui font qu'une petite salle de bain fonctionne aussi bien qu'une grande. C'est souvent dans les petits espaces qu'on est le plus fier du résultat.`,
    features: [
      "Carrelage en diagonale agrandissant",
      "Niches de rangement intégrées",
      "Douche compacte sur mesure",
      "Mobilier suspendu optimisé",
      "Miroirs et éclairage stratégiques",
      "Conseil en aménagement inclus",
    ],
  },
];

const breadcrumbSchema = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": [
    {
      "@type": "ListItem",
      "position": 1,
      "name": "Accueil",
      "item": "https://carreaux-bat.ch/"
    },
    {
      "@type": "ListItem",
      "position": 2,
      "name": "Services",
      "item": "https://carreaux-bat.ch/services"
    }
  ]
};

const servicesPageSchema = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  "name": "Services de Carrelage & Rénovation en Valais",
  "description": "Services de carrelage en Valais par Carreaux-Bat. Pose de carrelage, rénovation salle de bain, douche italienne, faïence, mosaïque et carrelage extérieur.",
  "url": "https://carreaux-bat.ch/services",
  "mainEntity": {
    "@type": "LocalBusiness",
    "name": "Carreaux-Bat Valais",
    "telephone": "+41 77 511 75 52",
    "areaServed": {
      "@type": "AdministrativeArea",
      "name": "Valais"
    }
  }
};

export default function ServicesPage() {
  return (
    <div className="min-h-screen">
      <SeoHead
        title="Services de Carrelage | Entreprise de Carrelage & Carreleur en Valais"
        description="Services de carrelage en Valais par Carreaux-Bat, entreprise de carrelage et société de carrelage. Service de carrelage par carreleur à Grône, Sion, Sierre, Martigny, Crans-Montana, Verbier, Nendaz, Vercorin et Nax. Pose de carrelage, rénovation salle de bain, douche italienne, faïence, mosaïque et carrelage extérieur terrasse."
        keywords="service de carrelage Valais, entreprise de carrelage Grône, entreprise de carrelage Sion, entreprise de carrelage Sierre, entreprise de carrelage Martigny, entreprise de carrelage Crans-Montana, entreprise de carrelage Verbier, entreprise de carrelage Nendaz, entreprise de carrelage Vercorin, entreprise de carrelage Nax, société de carrelage Valais, carreleur Valais, pose de carrelage, rénovation salle de bain, douche italienne, faïence mosaïque, carrelage extérieur terrasse"
        canonical="https://carreaux-bat.ch/services"
        ogTitle="Nos Services de Carrelage & Rénovation en Valais"
        ogDescription="Pose de carrelage, rénovation salle de bain, douche italienne, faïence et mosaïque. Découvrez nos prestations dans le Valais."
        ogImage="/images/services-hero.jpg"
        schema={{
          "@context": "https://schema.org",
          "@graph": [servicesPageSchema, breadcrumbSchema]
        }}
      />
      <Navbar />

      {/* Hero */}
      <section className="relative pt-32 pb-20 overflow-hidden">
        <img
          src="/images/services-hero.jpg"
          alt="Services carrelage Valais"
          className="absolute inset-0 w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/70"></div>
        <div className="relative z-10 max-w-7xl mx-auto px-6 text-center">
          <span className="inline-block mb-4 px-4 py-1.5 bg-amber-700/80 text-white text-xs font-medium tracking-widest uppercase rounded-full">
            Nos prestations
          </span>
          <h1 className="text-5xl font-bold text-white mb-4">Nos Services</h1>
          <p className="text-white/70 max-w-xl mx-auto text-sm leading-relaxed">
            Carrelage, rénovation de salle de bain, douche italienne — le métier qu'on pratique tous les jours, dans les maisons du Valais.
          </p>
          <div className="flex items-center justify-center gap-2 mt-6 text-sm text-white/50">
            <Link to="/" className="hover:text-amber-400 transition-colors">Accueil</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-white">Services</span>
          </div>
        </div>
      </section>

      {/* Services list */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="space-y-20">
            {services.map((service, index) => (
              <div
                key={service.id}
                id={service.id}
                className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ${index % 2 === 1 ? "lg:flex-row-reverse" : ""}`}
              >
                <div className={index % 2 === 1 ? "lg:order-2" : ""}>
                  <div className="relative rounded-lg overflow-hidden h-80">
                    <img
                      src={service.img}
                      alt={service.title}
                      className={`w-full h-full object-cover ${service.imgPosition ?? 'object-top'}`}
                    />
                    <div className="absolute top-4 left-4 w-12 h-12 flex items-center justify-center bg-amber-700 rounded-lg">
                      <i className={`${service.icon} text-white text-xl`}></i>
                    </div>
                  </div>
                </div>
                <div className={index % 2 === 1 ? "lg:order-1" : ""}>
                  <span className="text-xs uppercase tracking-widest text-amber-700 font-medium">{service.subtitle}</span>
                  <h2 className="mt-2 text-3xl font-bold text-stone-900 mb-4">{service.title}</h2>
                  <div className="space-y-3 mb-6">
                    {service.description.split("\n\n").map((para, i) => (
                      <p key={i} className="text-sm text-stone-500 leading-relaxed">{para}</p>
                    ))}
                  </div>
                  <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2 mb-6">
                    {service.features.map((feat) => (
                      <li key={feat} className="flex items-center gap-2 text-sm text-stone-700">
                        <i className="ri-check-line text-amber-600 flex-shrink-0"></i>
                        {feat}
                      </li>
                    ))}
                  </ul>
                  <Link
                    to="/contact"
                    className="inline-flex items-center gap-2 px-6 py-3 bg-amber-700 text-white text-sm font-medium rounded-full hover:bg-amber-800 transition-colors whitespace-nowrap"
                  >
                    Demander un devis
                    <i className="ri-arrow-right-line"></i>
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-stone-900">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-3xl font-bold text-white mb-4">Votre projet en Valais</h2>
          <p className="text-stone-400 text-sm mb-8 max-w-xl mx-auto">
            Vous avez un projet de carrelage ou une salle de bain à refaire ? On vient voir, on évalue, on discute. Pas d'engagement, juste un échange franc.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/contact"
              className="px-8 py-3.5 bg-amber-700 text-white font-medium rounded-full hover:bg-amber-600 transition-colors whitespace-nowrap"
            >
              Devis gratuit
            </Link>
            <a
              href="tel:+41775117552"
              className="px-8 py-3.5 border border-stone-600 text-stone-300 font-medium rounded-full hover:border-amber-600 hover:text-amber-400 transition-colors whitespace-nowrap flex items-center justify-center gap-2"
            >
              <i className="ri-phone-line"></i>
              +41 77 511 75 52
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
